export const ASSET_MANAGEMENT_GET_FORM_DATA = {
    ASSET_MANAGEMENT_GET_FORM_DATA_LOAD: "ASSET_MANAGEMENT_GET_FORM_DATA_LOAD",
    ASSET_MANAGEMENT_GET_FORM_DATA_SUCCESS: "ASSET_MANAGEMENT_GET_FORM_DATA_SUCCESS",
    ASSET_MANAGEMENT_GET_FORM_DATA_FAIL: "ASSET_MANAGEMENT_GET_FORM_DATA_FAIL"
}
export const ASSET_MANAGEMENT_GET_FORM_DATA_API = "/form/allform"


export const ASSET_MANAGEMENT_GET_BY_ID = {
    ASSET_MANAGEMENT_GET_BY_ID_LOAD: "ASSET_MANAGEMENT_GET_BY_ID_LOAD",
    ASSET_MANAGEMENT_GET_BY_ID_SUCCESS: "ASSET_MANAGEMENT_GET_BY_ID_SUCCESS",
    ASSET_MANAGEMENT_GET_BY_ID_FAIL: "ASSET_MANAGEMENT_GET_BY_ID_FAIL"
}

export const ASSET_MANAGEMENT_GET_BY_ID_API = "/form/formDataAllActiveStores/"

export const FORMLIST_GET_BY_ID = {
    FORMLIST_GET_BY_ID_LOAD: "FORMLIST_GET_BY_ID_LOAD",
    FORMLIST_GET_BY_ID_SUCCESS: "FORMLIST_GET_BY_ID_SUCCESS",
    FORMLIST_GET_BY_ID_FAIL: "FORMLIST_GET_BY_ID_FAIL"
}
export const FORMLIST_GET_BY_ID_API = "/form/form/"

export const FORMLIST_ADD_DATA = {
    FORMLIST_ADD_DATA_LOAD: "FORMLIST_ADD_DATA_LOAD",
    FORMLIST_ADD_DATA_SUCCESS: "FORMLIST_ADD_DATA_SUCCESS",
    FORMLIST_ADD_DATA_FAIL: "FORMLIST_ADD_DATA_FAIL"
}
export const FORMLIST_ADD_DATA_API = "/form/createForm"

export const FORMLIST_UPDATE_DATA = {
    FORMLIST_UPDATE_DATA_LOAD: "FORMLIST_UPDATE_DATA_LOAD",
    FORMLIST_UPDATE_DATA_SUCCESS: "FORMLIST_UPDATE_DATA_SUCCESS",
    FORMLIST_UPDATE_DATA_FAIL: "FORMLIST_UPDATE_DATA_FAIL"
}
export const FORMLIST_UPDATE_DATA_API = "/form/updateForm/"

export const FORMLIST_UPDATE_STATUS = {
    FORMLIST_UPDATE_STATUS_LOAD: "FORMLIST_UPDATE_STATUS_LOAD",
    FORMLIST_UPDATE_STATUS_SUCCESS: "FORMLIST_UPDATE_STATUS_SUCCESS",
    FORMLIST_UPDATE_STATUS_FAIL: "FORMLIST_UPDATE_STATUS_FAIL"
}
export const FORMLIST_UPDATE_STATUS_API = "/form/toggleFormStatus/"

